module.exports = __webpack_public_path__ + "img/dl3dvn-currency-guide-3.a79ef988.png";